import { useState, useEffect, useContext } from 'react';

import { cmnContext } from '../../../../../common/CmnContext';
import { LiveReserveContext } from '../../LiveLessonReseveContext';
import Modal from '../../../../../common/Modal';
import LiveReserveSelectInstructorSelect from './select/LiveReserveSelectInstructorSelect';
import LiveReserveSelectInstructorModal from './modal/LiveReserveSelectInstructorModal';

import { LiveReserveInstructorModel } from '../../../../../../models/lesson/live/reserve/instructor/LiveReserveInstructor';


// 講師選択
function LiveReserveSelectInstructor() {
  const isPc = useContext(cmnContext).isPc;

  const {
    isLoading,
    instId,
    instructors,
    noSlotInstructors,
  } = useContext(LiveReserveContext);

  const [selectInst, setSelectInst] = useState<LiveReserveInstructorModel | null>(null);
  // 講師未選択画像
  const noSelectImg = '/images/page/lesson/live/noselect_inst.png';

  const [isDispModal, setIsDispModal] = useState<boolean>(false);


  // 選択講師情報
  //   ★SPEAKOUT-1853 空き枠が1つも無い講師は予約用の一覧($instructors)から外れている。
  //     講師一覧の「予約待ちリクエスト」(/lesson/live?inst_id=N)で飛んでくるのは
  //     まさにその講師なので、両方から探さないと「講師を指定しない」に見えてしまう。
  useEffect(() => {
    const allInstructors = (instructors || []).concat(noSlotInstructors || []);
    const newSltInst = allInstructors.find((inst: any) => inst.inst_id === instId);
    setSelectInst(newSltInst);
  }, [isLoading, instId, instructors, noSlotInstructors])


  // 講師情報から画像取得
  function getInstImg(inst: any) {
    // (API処理)設定されていてもサーバ上に画像ファイルがなければデフォルト
    let imgSrc = '';
    if(inst.image_file) {
      // 画像設定
      const now = new Date();
      const yearMonth = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}`;
      imgSrc = `/images/instructor/${inst.image_file}?${yearMonth}`;
    } else if(inst.gender == '1') {
      // 男性
      imgSrc = '/images/page/lesson/live/noimage_male.png';
    } else {
      // 女性
      imgSrc = '/images/page/lesson/live/noimage_female.png';
    }
    return imgSrc;
  }
  // 講師の趣味・スコア情報
  function getInstDetailInfo(inst: any) {
    // 講師情報
    let newInfo = '';
    if(inst) {
      if(inst.hobby) {
        // 趣味
        newInfo = inst.hobby;
      } else if(inst.score) {
        // スコア
        newInfo = inst.score;
      }
      // 改行除去
      newInfo = newInfo.replace(/\n/g, ' ');
    }

    return newInfo;
  }


  
  return (
    <div style={{marginBottom: 10}}>
      <label className="control-label" style={{
        margin: '15px 0 5px 0',
        backgroundColor: '#eaffea',
        padding: '0.25em 3em 0.25em 0.5em',
        borderLeft: 'solid 5px #3c8c3c',
      }}>レッスンを受ける講師を選択</label>

      <div style={{marginBottom: isPc? '0': '5px'}}>
        <input type="hidden" name="inst_id" value={instId} />

        {/* 選択講師 */}
        <LiveReserveSelectInstructorSelect
          setIsDispModal={setIsDispModal}
          selectInst={selectInst}
          noSelectImg={noSelectImg}
          getInstImg={getInstImg}
          getInstDetailInfo={getInstDetailInfo}
        />

        {/* 選択モーダル */}
        <Modal
          comp={
            <LiveReserveSelectInstructorModal
              selectInst={selectInst}
              setIsDispModal={setIsDispModal}
              getInstImg={getInstImg}
              getInstDetailInfo={getInstDetailInfo}
            />
          }
          isDispModal={isDispModal}
          setIsDispModal={setIsDispModal}
          modalWidth={isPc? '60%' : '95%'}
        />
      </div>

    </div>
  );
}
  
export default LiveReserveSelectInstructor;